





















import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import BookFormInfo from '@/modules/Book/components/forms/BookFormInfo.vue'
import { newBook, editBook } from '@/modules/Book/gql/book.gql'
import { IBookInfoInput } from '@/modules/Book/interfaces/book-form'
import { Book } from '@/modules/Book/interfaces/book'
import { states } from '@/utils/us_states'
import delNonNumCode from '@/utils/delNonNumCode'

@Component({
  components: {
    BookFormInfo,
    AppDialog,
    AppSteps
  }
})
export default class BookForm extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Book }) readonly book!: Book

  showDialog = false

  loading = false

  stepIndex = 0
  steps = [
    ['Information', 770, 301]
  ]

  infoInput: IBookInfoInput = {
    name: ''
  }

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.book
        ? 'Save'
        : 'Create'
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    if (val) {
      this.resetStep()
      this.initInput()
    }
    this.showDialog = val
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.book) {
      const {
        name
      } = this.book

      this.infoInput = {
        name
      }
    } else {
      this.clearForm()
    }
  }

  handleStepClick (index: number) {
    if (!this.book) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.book) {
        this.handleUpdate()
      } else {
        this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    if (this.stepIndex > 0) {
      this.stepIndex -= 1
    }
  }

  async handleCreate () {
    const {
      infoInput: {
        name
      }
    } = this

    try {
      const res = await this.$apollo.mutate({
        mutation: newBook,
        variables: {
          bookInput: {
            name
          }
        }
      })
      this.clearForm()
      this.onSuccess('Create the new source successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    const {
      infoInput: {
        name
      }
    } = this

    try {
      const res = await this.$apollo.mutate({
        mutation: editBook,
        variables: {
          bookId: +this.book.id,
          bookInput: {
            name
          }
        }
      })
      this.clearForm()
      this.onSuccess('Update book successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  clearForm () {
    this.loading = false
    this.infoInput = {
      name: ''
    }
  }

  @Emit('hide')
  handleHide () {
    this.$emit('input', false)
  }

  @Emit('cancel')
  handleCancel () {
    this.handleHide()
    this.clearForm()
  }

  @Emit('success')
  @Emit('hide')
  onSuccess (msg = '') {
    this.handleHide()
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }
}
